import type { Destinations } from "@/queries/getDestinations";
import type { ReactNode } from "react";
import { getTime } from "../destinations/getTime";
import { listThemes, listVoyagesCulturels } from "../ideas/Ideas";
import { Container } from "./Container";
import type { Data } from "./MobileMenuInner";
import { mobileColumns } from "./mobileColumns";

type Props = {
  destinations: Destinations;
  menuThemeCards: ReactNode;
};
export const MobileMenu = ({ destinations, menuThemeCards }: Props) => {
  let allData: Data = {
    root: {
      id: "root",
      children: [
        {
          title: "Destinations",
          to: "destinations",
        },
        {
          title: "Thématiques",
          to: "ideas",
        },
        {
          title: "Voyages sur mesure",
          to: "surMesure",
        },
        {
          title: "Conférenciers",
          href: "/conferenciers/",
        },
      ],
    },
    destinations: {
      id: "destinations",
      title: "Destinations",
      back: "root",
      children: [],
      isDestination: true,
    },
    ideas: {
      id: "ideas",
      title: "Thèmes",
      back: "root",
      children: [
        {
          title: "Voyages culturels",
          to: "voyages-culturels",
        },
        {
          title: "Thèmes",
          to: "themes",
        },
        {
          title: "Quand souhaitez-vous partir ?",
          to: "date",
        },
      ],
    },
    surMesure: {
      id: "surMesure",
      title: "Voyages sur mesure",
      back: "root",
      children: [],
    },
    themes: {
      id: "themes",
      title: "Thèmes",
      back: "ideas",
      children: listThemes,
    },
    date: {
      id: "date",
      title: "Quand souhaitez-vous partir ?",
      back: "ideas",
      children: [
        {
          title: "Janvier",
          href: `/recherche/?gte=${getTime(0).start}&lte=${getTime(0).end}`,
        },
        {
          title: "Février",
          href: `/recherche/?gte=${getTime(1).start}&lte=${getTime(1).end}`,
        },
        {
          title: "Mars",
          href: `/recherche/?gte=${getTime(2).start}&lte=${getTime(2).end}`,
        },
        {
          title: "Avril",
          href: `/recherche/?gte=${getTime(3).start}&lte=${getTime(3).end}`,
        },
        {
          title: "Mai",
          href: `/recherche/?gte=${getTime(4).start}&lte=${getTime(4).end}`,
        },
        {
          title: "Juin",
          href: `/recherche/?gte=${getTime(5).start}&lte=${getTime(5).end}`,
        },
        {
          title: "Juillet",
          href: `/recherche/?gte=${getTime(6).start}&lte=${getTime(6).end}`,
        },
        {
          title: "Août",
          href: `/recherche/?gte=${getTime(7).start}&lte=${getTime(7).end}`,
        },
        {
          title: "Septembre",
          href: `/recherche/?gte=${getTime(8).start}&lte=${getTime(8).end}`,
        },
        {
          title: "Octobre",
          href: `/recherche/?gte=${getTime(9).start}&lte=${getTime(9).end}`,
        },
        {
          title: "Novembre",
          href: `/recherche/?gte=${getTime(10).start}&lte=${getTime(10).end}`,
        },
        {
          title: "Décembre",
          href: `/recherche/?gte=${getTime(11).start}&lte=${getTime(11).end}`,
        },
      ],
    },
    "voyages-culturels": {
      id: "voyages-culturels",
      title: "Voyages culturels",
      back: "ideas",
      children: listVoyagesCulturels,
    },
  };

  const regions = destinations.map((destination) => ({
    id: destination.id,
    title: destination.title,
    alias: destination.alias,
    places: destination.countries
      .map((child) => ({
        id: child.id,
        title: child.title,
        alias: child.alias,
        departures: child.count,
      }))
      .filter((d) => d.departures !== 0),
  }));

  const dest: Array<{
    title: string;
    to?: string;
    href?: string;
  }> = [];

  for (const element of mobileColumns) {
    const dests = regions
      .filter((d) => element.alias.includes(d.alias))
      .flatMap((d) => d.places)
      .sort((a, b) => a.title.localeCompare(b.title));

    dest.push({
      title: element.title,
      to: element.title,
    });

    allData = {
      ...allData,
      [element.title]: {
        id: element.title,
        title: element.title,
        back: "destinations",
        children: dests.map((place) => ({
          title: place.title,
          href: `/voyages-culturels/${place.alias}/`,
        })),
      },
    };
  }

  allData.destinations.children = dest;

  return <Container data={allData} menuThemeCards={menuThemeCards} />;
};
